// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"727242fc","569":"fcf14f58"}[chunkId] + ".chunk.css";
};